import { InternalCanvas } from '../canvas';
import { ToolMode } from '../mode';

export interface UpdateObjectRect {
    left: number;
    top: number;
    width: number;
    height: number;

    x1: number;
    y1: number;
    x2: number;
    y2: number;
}

export abstract class ObjectBuilder<
    TObject extends fabric.Object = fabric.Object
> {
    constructor(
        protected initialPoint: fabric.Point,
        protected _object: TObject,
    ) {}

    private _setObject(newObject: TObject | undefined | void): void {
        if (!newObject) {
            return;
        }
        newObject.uuid = this._object.uuid;
        this._object = newObject;
    }

    public get object(): TObject {
        return this._object;
    }

    public update({ absolutePointer, e }: fabric.IEvent): void {
        if (!absolutePointer) {
            return;
        }

        const { altKey: mouseCenter, ctrlKey: equalSides } = e as MouseEvent;

        const { x: x1, y: y1 } = this.initialPoint;
        const { x: x2, y: y2 } = absolutePointer;
        const run = Math.abs(x1 - x2);
        const rise = Math.abs(y1 - y2);
        const size = Math.max(rise, run);
        const width = equalSides ? size : run;
        const height = equalSides ? size : rise;

        this._setObject(
            this._updateObject({
                x1,
                y1,
                x2,
                y2,
                left: mouseCenter ? x1 - width / 2 : Math.min(x1, x2),
                top: mouseCenter ? y1 - height / 2 : Math.min(y1, y2),
                width,
                height,
            }),
        );
    }

    protected abstract _updateObject(
        rect: UpdateObjectRect,
    ): TObject | undefined | void;

    public finalize(): TObject | void {
        this._object.selectable = false;
        return this._finalizeObject();
    }

    protected _finalizeObject(): TObject | void {
        return this._object;
    }
}

export class DrawingTool {
    constructor(public mode: ToolMode = ToolMode.CUSTOMDRAW) {}

    public createObjectBuilder(
        _canvas: InternalCanvas,
        _initialPoint: fabric.Point,
    ): ObjectBuilder | undefined {
        return;
    }

    public handleMouseMove(
        _canvas: InternalCanvas,
        _event: fabric.IEvent,
    ): boolean {
        return false;
    }
}
